import { useState } from "react";
import ApplyStockTakingDialog from "../dialogTypes/ApplyStockTakingDialog";
import MomSysApplyStockTakingButtonLayout from "../layout/MomSysApplyStockTakingButtonLayout";

function MomSysApplyStockTakingButton(props) {

  const { id, schema, stockTakingId, grid, refresh, onSuccess, shipmentDetailId, ...others } = props;
  
  const [open, setOpen] = useState(false);

  const onOpen = () => {
    setOpen ( true );

};

  const onClose = () => {

    setOpen(false);

  };

  const onUpdateSuccess = (msg) => {

    if (onSuccess) {

      onSuccess(msg);

    }

    refresh.refresh();

  };

  return (
    <>
      <MomSysApplyStockTakingButtonLayout id={id + "create-button"} onClick={onOpen} {...others}/>
      <ApplyStockTakingDialog
        id={id + "create-dialog"}
        schema={schema}
        initialData={undefined}
        stockTakingId = {stockTakingId}
        open={open}
        onClose={onClose}
        onSuccess={onUpdateSuccess}
      />
    </> 
  );
}

export default MomSysApplyStockTakingButton;
